
import http from '@/utils/http'

export default {
  // 查询资讯文章接口
  getArticle (id) {
    return http.get(`/promotion/v1/api/weChatArticle/${id}`)
  },
  // 获取推荐律师接口
  getLawyerList (params) {
    return http.get('/promotion/v1/api/lawyer/reviewLawyerList?pageIndex=' + params.pageIndex +
      '&pageSize=' + params.pageSize + '&expertField=' + params.expertField)
  },
  // 资讯文章列表接口
  getArticleList (params) {
    return http.get('/promotion/v1/api/weChatArticle/recommend?pageNo=' + params.pageIndex + '&pageSize=' + params.pageSize +
      '&title=' + '&type=' + params.type + '&excludeId=' + params.id
    )
  },
  // 获取律师详情接口
  getLawyerDetail (params) {
    return http.get(`/promotion/v1/api/lawyer/review/${params}`)
  }
}



// WEBPACK FOOTER //
// ./src/components/article-detail/api/index.js